import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 房间party礼包信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90607094
export const party_activity_info = createAsyncThunk(
  'party_activity_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'count_down' | 'room_list'>>
    >(
      '/live/activity/party_activity_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 房间party礼包购买 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90607093
export const party_activity_buy = createAsyncThunk(
  'party_activity_buy',
  // type int 0 给自己购买 1赠送
  // to_mid 被赠送人id
  async (
    arg:
      | {id: number; type: 0; room_id: number}
      | {id: number; type: 1; to_mid: number},
    store: any
  ) => {
    // 0成功 1 余额不足 2 数量不足
    const resp = await http.post<HiyaRes<{status: 0 | 1 | 2; err_msg: string}>>(
      '/live/activity/party_activity_buy',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export interface roominfo {
  room_id: number //	房间id
  desc: string //		描述
  avatar: string //		图片
  count_down: number //	倒计时
}
interface GoodInfo {
  type: number //		商品类型

  price: number //		价格

  pic: number //	图片

  name: number //	商品名称
  effect: number // 时间/个数
}
export interface Info {
  id: number //	礼包id

  name: string //	礼包名称

  price: number //		礼包价格

  value: number //		礼包原价

  discount: number //		折扣百分比

  limit: number //		礼包购买限制
  pic: string // 房间预览图
  goods_list: GoodInfo[] // 商品列表
}
interface InitialStateType {
  list?: Info[]
  count_down?: number
  room_list?: roominfo[]
}

const initialState: InitialStateType = {}

export const RoomPartyGiftSlice = createSlice({
  name: 'RoomPartyGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(party_activity_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default RoomPartyGiftSlice.reducer
export const RoomPartyGiftActions = RoomPartyGiftSlice.actions
